import { Check, X } from 'lucide-react';
import { useI18n } from '../lib/i18n';

const isEmail = (s: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

/**
 * Previsualiza cómo el backend va a interpretar el campo "To": mismos pasos que parseRecipients
 * (separa por coma/;/salto; a cada chunk: email tal cual → si no, sin espacios → si no, split por
 * espacios). Devuelve válidos e inválidos para pintarlos distinto (verde/rojo).
 */
export function parseRecipientsPreview(raw: string): { valid: string[]; invalid: string[] } {
  const valid: string[] = [];
  const invalid: string[] = [];
  const seen = new Set<string>();
  const addValid = (s: string) => { const k = s.toLowerCase(); if (!seen.has(k)) { seen.add(k); valid.push(s); } };
  for (const chunk of raw.split(/[,;\n]+/).map((s) => s.trim()).filter(Boolean)) {
    if (isEmail(chunk)) { addValid(chunk); continue; }
    const noSpaces = chunk.replace(/\s+/g, '');
    if (isEmail(noSpaces)) { addValid(noSpaces); continue; }
    for (const p of chunk.split(/\s+/)) { if (isEmail(p)) addValid(p); else if (p) invalid.push(p); }
  }
  return { valid, invalid };
}

/** Chips del campo "To": cada email válido en VERDE, cualquier cosa que NO sea email en ROJO
 *  (así el usuario ve por qué falla, ej. "thimoty@email." + "com"). Solo visual. */
export function RecipientChips({ to }: { to: string }) {
  const { t } = useI18n();
  const { valid, invalid } = parseRecipientsPreview(to);
  if (!valid.length && !invalid.length) return null;
  const base: React.CSSProperties = { fontSize: 'var(--fs-2xs)', fontWeight: 'var(--fw-semibold)' as React.CSSProperties['fontWeight'], borderRadius: 999, padding: '2px 9px', display: 'inline-flex', alignItems: 'center', gap: 4 };
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
      {valid.map((e) => (
        <span key={`v${e}`} style={{ ...base, background: 'var(--green-soft)', color: 'var(--green)', border: '1px solid var(--green)' }}><Check size={12} strokeWidth={1.75} /> {e}</span>
      ))}
      {invalid.map((e, i) => (
        <span key={`i${i}-${e}`} title={t('em.invalidEmailHint')} style={{ ...base, background: 'var(--red-soft)', color: 'var(--red)', border: '1px solid var(--red)' }}><X size={12} strokeWidth={1.75} /> {e}</span>
      ))}
    </div>
  );
}
